import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function Testimonials() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section id="testimonios" className="w-full bg-white py-20 px-4" data-id="element-134">
      <div className="max-w-7xl mx-auto" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-136">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-137">
            O que dizem os professores que já usam
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-138">
          <motion.div variants={itemVariants} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow duration-300" data-id="element-139">
            <div className="flex items-center mb-6" data-id="element-140">
              <div className="w-14 h-14 rounded-full bg-red-700 flex items-center justify-center text-white text-xl font-bold" data-id="element-141">
                A
              </div>
              <div className="ml-4" data-id="element-142">
                <h3 className="font-bold text-gray-900" data-id="element-143">Ana Paula M.</h3>
                <p className="text-sm text-gray-600" data-id="element-144">
                  Professora de Artes — Rede Municipal, SP
                </p>
              </div>
            </div>

            <p className="text-gray-700 leading-relaxed italic" data-id="element-145">
              "Material incrível! Os planos de aula do Fundamental I me salvaram
              o ano. Meus alunos adoraram a unidade de Arte Urbana. Recomendo
              demais!"
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow duration-300" data-id="element-146">
            <div className="flex items-center mb-6" data-id="element-147">
              <div className="w-14 h-14 rounded-full bg-red-700 flex items-center justify-center text-white text-xl font-bold" data-id="element-148">
                C
              </div>
              <div className="ml-4" data-id="element-149">
                <h3 className="font-bold text-gray-900" data-id="element-150">Carla S.</h3>
                <p className="text-sm text-gray-600" data-id="element-151">
                  Professora de Artes — Escola Particular, RJ
                </p>
              </div>
            </div>

            <p className="text-gray-700 leading-relaxed italic" data-id="element-152">
              "O bônus de avaliação é ouro puro. Finalmente consigo dar nota em
              Artes sem me sentir injusta. As rubricas são muito claras e
              práticas."
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow duration-300" data-id="element-153">
            <div className="flex items-center mb-6" data-id="element-154">
              <div className="w-14 h-14 rounded-full bg-red-700 flex items-center justify-center text-white text-xl font-bold" data-id="element-155">
                R
              </div>
              <div className="ml-4" data-id="element-156">
                <h3 className="font-bold text-gray-900" data-id="element-157">Rodrigo T.</h3>
                <p className="text-sm text-gray-600" data-id="element-158">
                  Professor Polivalente — Anos Iniciais, MG
                </p>
              </div>
            </div>

            <p className="text-gray-700 leading-relaxed italic" data-id="element-159">
              "Eu não sou especialista em Artes, mas com esse material consigo
              dar aulas lindas e bem fundamentadas. O guia de materiais
              econômicos é genial."
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}